module.exports = __webpack_public_path__ + "img/chevron.b3721d62.svg";